import { useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import Groups from './groups'
import Roles from './roles'

import {
	EuiPage,
	EuiPageBody,
	EuiTab,
	EuiTabs
} from '@equipmentshare/ds2'

import PermissionsCheck from 'components/PermissionsCheck'
import { Permission } from '../../../graphql'
import PageTitle from 'views/components/PageTitle/PageTitle'

export default function Permissions(): JSX.Element {
	const navigate = useNavigate()
	const location = useLocation()
	const defaultTab = location.pathname.startsWith( '/manage/permissions/roles' ) ? 'roles' : 'groups'

	const [ selectedTabId, setSelectedTabId ] = useState( defaultTab )
	const selectedTabContent = defaultTab === 'roles' ? <Roles /> : <Groups />

	const onSelectedTabChanged = ( id: string ) => {
		setSelectedTabId( id )
		navigate( `/manage/permissions/${id}` )
	}

	const fullHeight = 'eui-fullHeight'

	return (
		<PermissionsCheck permissionsToCheck={[ Permission.CanEditAllPermissions ]}>
			<EuiPage paddingSize="l">
				<EuiPageBody className={fullHeight}>
					<PageTitle title="Permissions" />
					<EuiTabs>
						<EuiTab
							onClick={() => onSelectedTabChanged( 'groups' )}
							isSelected={selectedTabId === 'groups'}
						>
							Groups
						</EuiTab>
						<EuiTab
							onClick={() => onSelectedTabChanged( 'roles' )}
							isSelected={selectedTabId === 'roles'}
						>
							Roles
						</EuiTab>
					</EuiTabs>
					{selectedTabContent}
				</EuiPageBody>
			</EuiPage>
		</PermissionsCheck>
	)
}
